import { IExperience } from '../interfaces/IExperience';
import '../styles/ItemExperience.css';

const ItemExperience = ({title,description}: IExperience) =>{
    return (
        <div className='item-experience'>
            <h3 className='item-experience__title'>
                {title}
            </h3>
            <p className='item-experience__description'>
                {description}
            </p>
        </div>
    )
}

export default ItemExperience;